module.exports = __webpack_public_path__ + "media/app/assets/specializations/monk/mistweaver-75c83974fa9bb53058084ddd38e49b64.png";